import React from 'react';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import styles from './index.module.scss'
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const EventsCard = (props) => {
  const {compData} = props;
  
  
  return (
    <div className={styles.wrapper}>
      <Row>
        {
          compData.map((item, key) => (
            <>
            {item?.acf?.desktopurl && 
              <Col lg={3} md={6} className='mb-5'>
              <div key={key} className={styles.itemWrapper}>
                <a href={`/our-attractions/${item?.id}/${item?.title?.rendered}`}>
                  <div className={styles.imgWrapper}>
                    <img src={item?.acf?.desktopurl} alt={item?.title?.rendered}  loading="lazy"/>
                  </div>
                  <div className={styles.textWrapper}>
                      <h3 dangerouslySetInnerHTML={{ __html: item?.title?.rendered }} />
                      <p dangerouslySetInnerHTML={{ __html: item?.acf?.shortDescription }} />
                      <p className={styles.viewMore}>View more<FontAwesomeIcon icon={faArrowRight} /></p>
                  </div>
                </a>
            </div> 
            </Col>
            }
            </>  
          ))
        }
      </Row>
    </div>
  );
};

export default EventsCard;
